import React, {useMemo} from 'react';
import {Chip, Stack, Typography} from "@mui/material";
import {sx} from './sx'
import ScannerIcon from '@mui/icons-material/Scanner';
import {
	ITrackableObjectSingleVoyage,
	ITrackableObjectVisitLogSingleVoyage
} from "@containers/singleVoyage/trackableObjects/types";


interface ITrackableObject extends ITrackableObjectSingleVoyage {
	trackableObjectVisits?: ITrackableObjectVisitLogSingleVoyage[]
}

export const TrackableObjectsInfoSingleVoyage = ({
													 trackableObjects
												 }: {
	trackableObjects: ITrackableObject[]
}) => {
	const objects: {
		name: string
		id:number
		isScanned: boolean
	}[] = useMemo(() => {
		return trackableObjects.map((item) => {
			return {
				id: item.id,
				name: item.name,
				isScanned: item?.trackableObjectVisits && item?.trackableObjectVisits?.length >= 1 && !!item.trackableObjectVisits.find((it) => !!it.readerId)
			}
		})
	}, [trackableObjects])
	return (
		<Stack
			sx={sx.root}
			gap={'1px'}
		>
			{trackableObjects?.length >= 1 && <Typography
                variant={'caption'}
                sx={sx.info}
            >
                <ScannerIcon fontSize={'small'}/>
				
				{objects.map((obj) => {
					return (
						<Chip
							size={'small'}
							key={obj.id}
							label={obj.name}
							variant={obj.isScanned ? 'filled' : 'outlined'}
							color={obj.isScanned ? 'success' : 'default'}
						/>
					)
					
				})}
            </Typography>}
		</Stack>
	);
};

